// PDF Footer.jsx
import styles from "./pdf.module.css";

const Footer = ({ pageNumber, totalPages }) => {
  return (
    <footer className={styles.pdf_footer}>
      <div className={styles.pdf_company_title}>
       ESPAC <span className={styles.pdf_black}>|</span> ESP ADVISORY AND CONSULTING{" "}
       
      </div>

      <div className={styles.pdf_company_info}>
        162/B/203, Lake Gardens, Flat no. 23 & 24, Vaijayanti, Kolkata – 700045
        &nbsp;|&nbsp;
        +91 70034 75215
        &nbsp;|&nbsp;
        espac<span className={styles.pdf_red}>@</span>espac.in
      </div>

      <div className={styles.pdf_disclaimer}>
        Investments in Mutual Funds are subject to market risks. Insurance is
        the subject matter of solicitation. Please read all scheme-related and
        policy-related documents carefully before investing or purchasing.
        Information, calculators, articles, illustrations, and other content
        provided here are for general informational and educational purposes
        only and should not be construed as personalized investment, legal, tax
        or financial advice. Investors should consult qualified professionals
        before making investment decisions.
      </div>
      
      {pageNumber>0 && (
      <div className={styles.pdf_page_number}>
        Page <b>{pageNumber}</b> of <b>{totalPages}</b>
      </div> ) }
    </footer>
  );
};

export default Footer;